import React from 'react'

const Title = ({field}) => {
  return (
    <label className="font-bold block mb-[1rem]">
    <span className="text-terciaria">{`${field.id})`}.</span> {field.label}{" "}
    {field.required && <span className="text-[#ff0000]">*</span>}
    {field.type === "checklist" && field.required && (
      <span className="font-light text-[#75767A] text-[13px] pl-2">
        (Marque todas as formas aceitas)
      </span>
    )}
  </label>
  )
}

export default Title